import store from "@/store";
import $service from "@/api-service";
import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import { jsonp } from "vue-jsonp";

import axios from "../api-service/http"

var isIos = function () {
  const u = navigator.userAgent
  return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1
}

var get_location_href = function () {
  if (isIos()) {
    return window['_location_href_'] || location.href
  }

  return location.href
}

var user_location_insert = function (res) {
  return axios.post("/v5/user-location-insert", {
    url: location.href,
    ...res
  });
}

/**
 * 高德定位
 * @returns
 */
export function getAMapLocation(pageUrl) {
  var url = pageUrl || get_location_href()
  budo_log.debug("#18 getAMapLocation", pageUrl, url)

  return new Promise((resolve, reject) => {
    $service.mv_get_jsapi_ticket(encodeURIComponent(url)).then(res => {
      var _timestamp
      var _noncestr
      var _sign
      var _appId

      if (res && res.data) {
        _timestamp = res.data.timestamp || res.data.timeStamp
        _noncestr = res.data.noncestr
        _sign = res.data.sign
        _appId = res.data.appId
      } else {
        budo_log.info("#24 mv_get_jsapi_ticket", pageUrl, url, res)
      }

      wx.config({
        appId: _appId, // 必填，公众号的唯一标识
        timestamp: _timestamp, // 必填，生成签名的时间戳
        nonceStr: _noncestr, // 必填，生成签名的随机串
        signature: _sign, // 必填，签名
        jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
      });

      wx.ready(function () {
        budo_log.debug("#42 wx.getLocation", res)

        wx.getLocation({
          type: "wgs84",
          success: function (res) {
            const lat = res.latitude;
            const lng = res.longitude;

            store.commit("setPosition", { lat: lat, lng: lng });

            jsonp(`https://apis.map.qq.com/ws/geocoder/v1/`, {
              output: "jsonp",
              key: "VGZBZ-MACHK-DTQJB-ACE53-W2BZE-CKF3T",
              location: `${lat},${lng}`
            }).then(res => {
              budo_log.debug("#42 jsonp geocoder", res);
              resolve(res?.result?.ad_info?.adcode);
            });

            user_location_insert(res)
          },

          cancel: function (res) {
            budo_log.info("#47 用户取消定位", res);
            reject(res);
          },

          fail: function (res) {
            budo_log.info("#51 定位失败", res);
            reject(res);
          }
        });
      });
    });
  });
}

/**
 * 获取用户地理位置
 * 后续添加wx定位
 */
export function movie_get_user_location(pageUrl) {
  budo_log.debug("#76 movie_get_user_location", pageUrl)

  // Toast.loading('定位中');
  return new Promise((resolve, reject) => {
    budo_log.debug("#67 AMap -> 开始获取用户定位")

    let promiseArray = [getAMapLocation(pageUrl), buildCityList()]
    Promise.all(promiseArray).then((result) => {
      let aMapLocationStr = result[0]
      budo_log.debug("#71 aMapLocationStr", aMapLocationStr)

      let cityList = result[1]

      if (!aMapLocationStr || aMapLocationStr.length < 1) {
        budo_log.info("#75 返回用户定位的地址为空")
        reject();
      }

      matchCityCode(cityList, aMapLocationStr).then((res) => {
        store.commit("setLocation", res);

        let selectedLocation = store.state.app.selectedLocation;
        if (!selectedLocation) {
          store.commit("setSelectedLocation", res);
          resolve();
          return;
        }

        budo_log.debug("#108 selectedLocation=", selectedLocation, "res=", res)

        // 城市不一致的 切换 电影里 是每次都要确认的 Mall 里有记忆
        if (selectedLocation && res.name && selectedLocation.name !== res.name) {
          Dialog.confirm({
            title: "切换城市",
            message: `定位到您在${res.name},是否切换?`
          }).then(() => {
            resolve(true);
            store.commit("setSelectedLocation", res);
          }).catch(() => {
            resolve(true);
          });
        } else {
          resolve();
        }
      }).catch((err) => {
        budo_log.info("#101 movie_get_user_location err", err);
        reject();
      });
    });
  });
}

/**
 * 匹配定位的地址是在哪个城市
 * @param {后台城市库缓存} cityList
 * @param {*匹配地址} address
 */
function matchCityCode(cityList, address) {
  budo_log.debug("#130 matchCityCode", cityList, address)

  return new Promise((resolve, reject) => {
    let result = null;
    if (typeof cityList === "string") cityList = JSON.parse(cityList);
    for (let item of cityList) {
      if (address.toString().slice(0, 4) === item.citycode.toString().slice(0, 4)) {
        result = item;
        break;
      }
    }
    if (result) {
      budo_log.info("#125 城市匹配成功:" + result.name);
      resolve(result);
    } else {
      budo_log.info("#128 城市匹配失败:" + address);
      reject("匹配失败");
    }
  });
}

/**
 * 本地缓存 后台城市库
 */
export function buildCityList() {
  return new Promise((resolve, reject) => {
    $service.m_city_list().then(res => {
      budo_log.info("#167 m_city_list", res)

      var city_list = []
      if (res && res.data && res.data.cityList) {
        city_list = res.data.cityList
      } else {
        budo_log.info("#146 no city_list", res)
      }

      resolve(city_list);
    }).catch((err) => {
      budo_log.info("#163 buildCityList err", err)
      reject(err);
    });
  });
}
